import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiCallSpinnerDriveInterceptorService } from './api-call-spinner-drive.intercepter.service';
import { TokenAppendAuth0InterceptorService } from './auth0/token-append.auth0.intercepter.service';
import { MockInterceptorService } from './mock-interceptor.service';

const devHttpInterceptorProviders = environment.mock
  ? [{ provide: HTTP_INTERCEPTORS, useClass: MockInterceptorService, multi: true }]
  : [];

export const httpInterceptorProviders = [
  ...devHttpInterceptorProviders,
  // リクエストにはトークンを付与する
  {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenAppendAuth0InterceptorService,
    multi: true,
  },
  // APIコールされるときはスピナーを回す
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ApiCallSpinnerDriveInterceptorService,
    multi: true,
  },
];
